export const getUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem("userInfo") || "null");
  } catch (error) {
    return null;
  }
};

export const getAuthHeaders = () => {
  const user = getUserInfo();
  if (user?.token) {
    return { Authorization: `Bearer ${user.token}` };
  }
  return {};
};

export const getOrCreateVisitorAnonId = () => {
  const key = "rechat_visitor_anon_id";
  let visitorId = localStorage.getItem(key);
  if (!visitorId) {
    visitorId = `anon_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(key, visitorId);
  }
  return visitorId;
};

export const getListingSessionKey = (listingId, agentId) =>
  `rechat_session:${listingId}:${agentId}`;

